import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { PoFieldModule } from '@po-ui/ng-components';
import { filter } from 'rxjs';

@Component({
  selector: 'app-date-range',
  imports: [PoFieldModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './date-range.component.html',
  styleUrl: './date-range.component.css',
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }]
})
export class DateRangeComponent implements OnInit {
  @Input() poClass!: string;
  @Input() startDateControlName!: string;
  @Input() endDateControlName!: string;
  @Input() required = false;

  private form!: FormGroup;

  constructor(private controlContainer: ControlContainer) { }

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
    const startCtrl = this.form.get(this.startDateControlName) as FormControl;
    const endCtrl = this.form.get(this.endDateControlName) as FormControl;
    if (!startCtrl || !endCtrl) {
      console.error('DateRangeComponent: controles não encontrados no FormGroup.');
      return;
    }

    startCtrl.addValidators(this.dateValidator);
    endCtrl.addValidators(this.dateValidator);

    const existing = this.form.validator ? [this.form.validator!] : [];
    this.form.setValidators([...existing, this.dateRangeValidator]);
    this.form.updateValueAndValidity({ emitEvent: false });

    startCtrl.valueChanges
      .pipe(filter(v => !!v))
      .subscribe(v => this.autoFillEnd(v));

    startCtrl.valueChanges.subscribe(() => this.form.updateValueAndValidity({ emitEvent: false }));
    endCtrl.valueChanges.subscribe(() => this.form.updateValueAndValidity({ emitEvent: false }));
  }

  onStartChange(date: any): void {
    this.autoFillEnd(this.stringDateToDate(date));
  }

  stringDateToDate(dateString: string): Date | undefined {
    if (!dateString) {
      return;
    }
    const [day, month, year] = dateString.split('/');
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  private autoFillEnd(value: Date | undefined) {
    const endCtrl = this.form.get(this.endDateControlName) as FormControl;
    if (value) {
      endCtrl.setValue(value, { emitEvent: false });
    }
  }

  private dateValidator: ValidatorFn = (control: AbstractControl) => {
    const val = control.value;
    if (!val) return null;
    const d = new Date(val);
    return isNaN(d.getTime()) ? { invalidDate: true } : null;
  };

  private dateRangeValidator: ValidatorFn = (group: AbstractControl) => {
    const start = group.get(this.startDateControlName)?.value;
    const end = group.get(this.endDateControlName)?.value;

    if (this.required && (!start && !end)) {
      return { dateRangeRequired: true };
    }
    if ((!start && end) || (start && !end)) return { dateRangeIncomplete: true };
    const sd = new Date(start);
    const ed = new Date(end);
    if (isNaN(sd.getTime()) || isNaN(ed.getTime())) return { dateRangeInvalid: true };
    if (sd > ed) return { dateRangeOrder: true };
    return null;
  };
}
